import React from "react";
import Navbar from "../components/Navbar";
import Whatsapp from "../components/Whatsapp";
import Footer from "../components/Footer";
import banner1 from "../assets/images/Gallery.jpg";
import "../assets/css/font-awesome/all.min.css";
import "../assets/css/flaticon/flaticon.css";
import "../assets/css/owl-carousel/owl.carousel.min.css";
import "../assets/css/magnific-popup/magnific-popup.css";
import "../assets/css/style.css";
import g1 from "../assets/images/g1.jpg";
import g2 from "../assets/images/g2.jpg";
import g3 from "../assets/images/g3.jpg";
import g4 from "../assets/images/g4.jpg";
import g5 from "../assets/images/g5.jpg";
import g6 from "../assets/images/g6.jpg";

const Gallery = () => {
  const images = [g1, g2, g3, g4, g5, g6];

  return (
    <div>
      <Navbar />
      <div
        className="project-banner"
        style={{ backgroundImage: `url(${banner1})`, marginTop: "50px" }}
      ></div>

      {/* 🖼️ GALLERY IMAGES */}
      <div className="container p-4 mt-5">
        <h2 className="text-2xl font-bold text-center mb-4 pt-5 text-black">
          Our Gallery
        </h2>
        <div className="row">
          {images.map((src, index) => (
            <div key={index} className="col-md-4 mb-4">
              <img
                src={src}
                alt={`Gallery ${index + 1}`}
                className="img-fluid rounded shadow"
              />
            </div>
          ))}
        </div>

        <section className="gallery-highlights-section">
          <div className="gallery-highlights-collage">
            <img className="gallery-collage-main" src={g2} alt="Well-planned project road" />
            <img className="gallery-collage-small" src={g1} alt="Project entrance" />
            <span className="gallery-collage-label">A better address starts here</span>
          </div>
          <div className="gallery-highlights-content">
            <span className="gallery-highlights-eyebrow">SEE THE DIFFERENCE</span>
            <h2>Made for the life you are building.</h2>
            <p>
              From the first welcome at the entrance to the greenery along every road,
              our developments are planned to feel calm, connected, and complete.
            </p>
            <div className="gallery-highlights-facts">
              <div><strong>01</strong><span>Thoughtful planning</span></div>
              <div><strong>02</strong><span>Connected locations</span></div>
              <div><strong>03</strong><span>Everyday comfort</span></div>
            </div>
            <a href="/contact" className="gallery-highlights-button">
              Plan a visit <span aria-hidden="true">&#8594;</span>
            </a>
          </div>
        </section>
      </div>

      <Whatsapp />
      <Footer />
    </div>
  );
};

export default Gallery;
